import React, { useState, useEffect, useRef } from 'react';
import { Send, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import api from '../services/api';
import { toast } from 'sonner';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const nameRef = useRef(null);

  useEffect(() => {
    try {
      if (nameRef.current) {
        nameRef.current.focus();
        nameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } catch (e) {}
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        type: 'general',
      };
      await api.post('/contact', payload);
      toast.success('Votre message a été envoyé avec succès!');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      toast.error('Erreur lors de l\'envoi du message');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="glass rounded-2xl p-4 md:p-6 shadow-xl border border-slate-700/50 animate-slideIn">
      <h2 className="text-lg md:text-xl font-bold text-white mb-3 md:mb-4 flex items-center gap-2">
        <MessageSquare className="w-5 h-5 text-purple-400" />
        Contact Simple
      </h2>

      <form onSubmit={handleSubmit} className="space-y-3 md:space-y-4">
        <div>
          <Input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Votre nom"
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            autoFocus
            ref={nameRef}
            data-testid="contact-name-input"
          />
        </div>

        <div>
          <Input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            data-testid="contact-email-input"
          />
        </div>

        <div>
          <Input
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Sujet"
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            data-testid="contact-subject-input"
          />
        </div>

        <div>
          <Textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Votre message"
            rows={4}
            required
            className="bg-slate-700 border-slate-600 text-white placeholder:text-gray-400 text-sm md:text-base"
            data-testid="contact-message-input"
          />
        </div>

        <Button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-purple-600 hover:bg-purple-700 text-sm md:text-base px-3 py-2 md:px-4 md:py-2"
          data-testid="contact-submit-btn"
        >
          <Send className="w-4 h-4 mr-2" />
          {isSubmitting ? 'Envoi...' : 'Envoyer'}
        </Button>
      </form>
    </div>
  );
};

export default ContactForm;
